/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type Currency = "AUD" | "CAD" | "CHF" | "EUR" | "GBP" | "JPY" | "MXN" | "USD" | "%future added value";
export type Price_item$ref = any;
export type Price_item = {
    readonly displayPrice: ReadonlyArray<{
        readonly convertedAmountList: ReadonlyArray<{
            readonly amount: number | null;
            readonly currency: Currency | null;
        } | null> | null;
        readonly quantityDisplay: string | null;
        readonly percentageOff: string | null;
        readonly type: string | null;
        readonly showPriceLabel: boolean | null;
        readonly showPriceVariability: boolean | null;
    } | null> | null;
    readonly " $refType": Price_item$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "Price_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "isTrade",
      "type": "Boolean",
      "defaultValue": false
    },
    {
      "kind": "LocalArgument",
      "name": "pageDisplayEnum",
      "type": "PageDisplayEnum",
      "defaultValue": "searchAndBrowse"
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "displayPrice",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "isTrade",
          "variableName": "isTrade"
        },
        {
          "kind": "Variable",
          "name": "page",
          "variableName": "pageDisplayEnum"
        }
      ],
      "concreteType": "ItemDisplayPriceType",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "convertedAmountList",
          "storageKey": null,
          "args": null,
          "concreteType": "ConvertedAmountList",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "amount",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "currency",
              "args": null,
              "storageKey": null
            }
          ]
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "quantityDisplay",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "percentageOff",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "type",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "showPriceLabel",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "showPriceVariability",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
(node as any).hash = '7ceea672646579013213dbad082b9dfc';
export default node;
